import {StoreType} from '../../../types/sharedTypes';

export const allianceParamsSelector = (state: StoreType) => {
  return state.allianceReducer.params;
}

export const allAlliancesSelector = (state: StoreType) => {
  return state.allianceReducer.alliancesResult;
}
